import QuoteIcon from '@/assets/quote.svg';
import { ScrollShadow } from '@nextui-org/react';

const testimonials = [
  {
    quote:
      'I was surprised to see how someone who is considered a difficult employee opened up when I practiced...',
    role: 'Senior Manager',
    company: 'Capital One',
  },
  {
    quote:
      'What I have learned in this program will improve the performance of our team. These are....',
    role: 'Senior Manager',
    company: 'Accenture',
  },
  {
    quote:
      'This program has exceeded my expectations. Not only did I learn a great deal about myself....',
    role: 'Strategy & Innovation leader',
    company: 'Cisco',
  },
  {
    quote:
      'The post-meeting review helped me acknowledge the power of the prep and to stay honest with...',
    role: 'Vice President',
    company: 'Wilton Re',
  },
];

const TestimonialCard = ({
  quote,
  role,
  company,
  className = '',
  equalHeight = false,
}: {
  quote: string;
  role: string;
  company: string;
  className?: string;
  equalHeight?: boolean;
}) => (
  <div
    className={`flex flex-col pb-4 pt-3 px-4 sm:px-5 bg-[#F4F2EE] rounded-lg border-1 ${
      equalHeight ? 'h-full' : ''
    } ${className}`}
  >
    <img
      src={QuoteIcon}
      alt="Quote"
      className="mb-4 h-[37px] w-8 shrink-0 self-start"
    />
    <p className={`text-xs leading-5 ${equalHeight ? 'mb-4 flex-1' : 'mb-6'}`}>
      "{quote}"
    </p>
    <div className={`text-xs ${equalHeight ? 'mt-auto' : ''}`}>
      <p className="font-semibold">{role}</p>
      <p className="text-gray-500">{company}</p>
    </div>
  </div>
);

const Testimonial = ({
  variant = 'scroll',
}: {
  variant?: 'scroll' | 'inline';
}) => {
  if (variant === 'inline') {
    return (
      <div className="w-full">
        <ScrollShadow orientation="horizontal" className="w-full md:hidden">
          <div className="flex items-stretch gap-4 pb-2">
            {testimonials.map((testimonial, index) => (
              <TestimonialCard
                key={index}
                {...testimonial}
                equalHeight
                className="w-[82vw] max-w-[220px] shrink-0 sm:w-[300px]"
              />
            ))}
          </div>
        </ScrollShadow>

        <div className="hidden md:grid md:grid-cols-2 md:gap-5 lg:grid-cols-4 lg:gap-12 pb-2">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} equalHeight />
          ))}
        </div>
      </div>
    );
  }

  return (
    <ScrollShadow orientation="horizontal" className="w-full">
      <div className="flex gap-6 pb-2">
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            {...testimonial}
            className="min-w-[200px] max-w-[200px] max-h-[256px]"
          />
        ))}
      </div>
    </ScrollShadow>
  );
};

export default Testimonial;
